import { PersonalizationApiParamsType, SuccessExternalLoginType } from '../../../types/authentication';
import detectBrowser from '../../../utils/detect-browser';
import detectDevice from '../../../utils/detect-device';
import md5 from '../../../utils/md5';
import analytics from '../../analytics';
import qualityEventsHelpers, { getUserAgentForQE } from '../quality-events.helpers';

export const AUTHENTICATION_EVENTS = {
    wrongAccountLogin(email_from_response: string, currentEmail: string) {
        qualityEventsHelpers.track({
            extra: JSON.stringify({
                email_from_response,
                html_input_value: document.querySelectorAll<HTMLInputElement>('input#formBasicEmail')[0]?.value,
                react_input_value: currentEmail
            }),
            page_url: window.location.href,
            type: 'wrongAccountLogin',
            user_agent: getUserAgentForQE(),
            user_device: detectDevice()
        });
    },
    onStartSignUp() {
        qualityEventsHelpers.track({
            type: 'signupStart'
        });
    },
    onExternalSignUp(type: SuccessExternalLoginType, sourceContext?: Object) {
        qualityEventsHelpers.track({
            type: `signupRequest${type}`,
            ...sourceContext
        });
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    signUpRegular(context: any) {
        qualityEventsHelpers.track({
            type: 'signupRequestRegular',
            ...context
        });
    },
    changeEmail() {
        qualityEventsHelpers.track({
            type: 'changeEmailViaSite'
        });
    },
    changePassword() {
        qualityEventsHelpers.track({
            type: 'changePasswordViaSite'
        });
    },
    forgotPassword() {
        qualityEventsHelpers.track({
            type: 'resetPasswordViaSite'
        });
    },
    finishRegistrationThankYouPageSubmit() {
        qualityEventsHelpers.track({
            page_url: window.location.href,
            type: 'finishRegistration:thankYouPageFormSubmit'
        });
    },
    finishRegistrationSetPasswordFromEmail() {
        qualityEventsHelpers.track({
            type: 'finishRegistration:setPasswordFromEmailLink'
        });
    },
    resetPasswordViaEmail() {
        qualityEventsHelpers.track({
            type: 'resetPasswordViaEmail'
        });
    },
    signUpCompleted() {
        analytics.push({
            event: 'gtmEvent',
            eventAction: 'signupCompleted',
            eventCategory: 'mkt-conversion',
            eventLabel: '',
            eventNonInteraction: true
        });

        qualityEventsHelpers.track({
            type: 'signupCompleted'
        });
    },
    wrongAccountLoginByValidate(new_id: number, stored_id: number) {
        qualityEventsHelpers.track({
            extra: JSON.stringify({
                new_id,
                stored_id
            }),
            page_url: window.location.href,
            type: 'wrongAccountLogin:byValidate',
            user_agent: getUserAgentForQE(),
            user_device: detectDevice()
        });
    },
    signUpFDL(sourceContext: { source: string }) {
        qualityEventsHelpers.track({
            type: 'signupRequestFDLEmail',
            ...sourceContext
        });
    },
    signUpEmail({ hash, email }: { hash: string; email: string }) {
        analytics.push({
            dynamicURL: window.location.pathname,
            emailSHA256: hash,
            event: 'gtmEvent',
            eventAction: 'signupRequest',
            eventCategory: 'mkt-conversion',
            eventLabel: 'regular_signup',
            eventNonInteraction: true,
            eventValue: 3,
            page: {
                searchResults: undefined,
                selectedAuthor: undefined,
                selectedGrades: undefined,
                selectedSubject: undefined,
                selectedType: undefined,
                type: undefined
            },
            pinterestInfo: {
                emailHash: md5(email)
            },
            testSegment: '',
            user: {
                isAuthor: '0',
                loginState: false,
                subjects: ''
            }
        });
    },
    sellerPageSignUp() {
        analytics.push({
            event: 'gtmEvent',
            eventAction: 'sellerPageSignUp',
            eventCategory: 'mkt-conversion',
            eventLabel: '',
            eventNonInteraction: true
        });
    },
    signUpConfirmedPreferences(personalisation: PersonalizationApiParamsType[]) {
        qualityEventsHelpers.track({
            type: 'signUpConfirmedPreferences',
            extra: JSON.stringify({ personalisation })
        });
    }
};
